/* eslint-disable react/no-string-refs */
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import withStyles from '@material-ui/core/styles/withStyles';

import Header from '../../mui-components/Header/Header';
import Sidebar from '../../mui-components/Sidebar/Sidebar';
import DashboardRouter from '../../routing/DashboardRouter';
import image from '../../assets/img/sidebar-2.jpg';
import logo from '../../assets/img/logos/ci-golden.png';
import style from './style';
import ciApi from '../../services/ciApi';
import UserTriggersListingView from '../../views/user-triggers/UserTriggersListingView';
import getDashboardRoutes from '../../routing/routes/dashboardRoutes';
import authActions from 'actions/authActions';
import { getLoggedUser, getOriginalUser, isImpersonating } from 'reducers/sessionReducer';
import { connect } from 'react-redux';
import { stopImpersonation } from 'utils/impersonation';
import { store } from 'store';
import { push } from 'react-router-redux';

class DashboardLayout extends React.Component {
  impersonationBannerRef = React.createRef();

  state = {
    mobileOpen: false,
    miniActive: false,
    triggerTypeRoutes: [],
  };

  async componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      this.scrollbar = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }

    const panel = this.refs.mainPanel;
    if (panel) {
      panel.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    }

    try {
      const response = await ciApi.call({
        httpMethod: 'get',
        endpoint: '/trigger-types',
      });

      let triggerTypeRoutes = [];

      if (
        response &&
        response.data &&
        Array.isArray(response.data.triggerTypes)
      ) {
        triggerTypeRoutes = response.data.triggerTypes.map(trigger => ({
          path: `/trigger-types/${trigger.id}/user-triggers`,
          name: trigger.description,
          permission: { action: 'read', subject: 'UserTrigger' },
          component: UserTriggersListingView,
        }));
      }

      this.setState({ triggerTypeRoutes });
    } catch (error) {
      console.error('Erro ao buscar trigger types:', error);
    }

    this.handleScroll();
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      this.scrollbar.destroy();
    }

    this.refs.mainPanel.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  handleScroll = () => {
    const panel = this.refs.mainPanel;
    const banner = this.impersonationBannerRef.current;
    if (!panel || !banner) return;

    const scrollY = panel.scrollTop;
    const isScrolled = scrollY > 0;

    banner.style.position = isScrolled ? 'fixed' : 'relative';
    banner.style.top = isScrolled ? '0' : 'unset';
  };

  sidebarMinimize = () => {
    this.setState({ miniActive: !this.state.miniActive });
  };

  handleStopImpersonation = async () => {
    try {
      await ciApi.call({
        httpMethod: 'post',
        endpoint: 'impersonation/stop',
      });

      store.dispatch(authActions.fetchCurrentUser());
      store.dispatch(push('/'));
    } catch (error) {
      console.error('Erro ao parar personificacao:', error);
    }
  };

  render() {
    const { classes, ...rest } = this.props;
    const mainPanel = `${classes.mainPanel} ${cx({
      [classes.mainPanelSidebarMini]: this.state.miniActive,
      [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
    })}`;
    const dashboardRoutes = getDashboardRoutes(this.state.triggerTypeRoutes);

    return (
      <div className={classes.wrapper}>
        {this.props.isImpersonating && (
          <div
            ref={this.impersonationBannerRef}
            style={{
              backgroundColor: 'rgba(197, 48, 48, 0.5)',
              color: 'white',
              padding: '10px',
              textAlign: 'center',
              position: 'relative',
              top: 'unset',
              left: 0,
              right: 0,
              zIndex: 2000,
              fontWeight: 'bold',
              fontSize: '16px',
              textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)',
            }}
          >
            Você está visualizando a plataforma como <strong>{this.props.user.name}</strong> (
            {this.props.user.email}).&nbsp;
            <button
              onClick={this.handleStopImpersonation}
              style={{
                backgroundColor: '#9B2C2C',
                border: 'none',
                color: 'white',
                padding: '8px 14px',
                marginLeft: '12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px',
                transition: 'background-color 0.2s ease',
              }}
              onMouseOver={e => e.currentTarget.style.backgroundColor = '#822727'}
              onMouseOut={e => e.currentTarget.style.backgroundColor = '#9B2C2C'}
            >
              Voltar para sua conta
            </button>
          </div>
        )}

        <Sidebar
          routes={dashboardRoutes}
          logoText="Confianca"
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize}
            miniActive={this.state.miniActive}
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          <div className={classes.content}>
            <div className={classes.container}>
              <DashboardRouter routes={dashboardRoutes} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isImpersonating: isImpersonating(state),
  user: getLoggedUser(state),
  originalUser: getOriginalUser(state),
});

export default connect(mapStateToProps)(
  withStyles(style)(DashboardLayout)
);
